import React, { useContext } from "react";
import styled from "styled-components";

import UIManager from "../../service/ui-manager";
import { Box, Row, Col, Button } from "../../comps";
import { Theme } from "../../theme/theme-provider";

import {
  faExpand,
  faCompressArrowsAlt,
} from "@fortawesome/free-solid-svg-icons";

const Wrapper = styled(Row)`
  width: 100%;
  height: 100%;
  align-items: center;
`;

export default () => {
  const handleFullScreen = () => {
    UIManager.enterFullScreenMode();
  };

  const handleMiniMode = () => {
    UIManager.enterMiniMode();
  };
  return (
    <Wrapper>
      <Button
        width=""
        height="60%"
        buttonTextColor={Theme.textColor.light}
        buttonBackground={Theme.color.RED_6}
        buttonName="Mini Mode"
        buttonIcon={faCompressArrowsAlt}
        buttonFontSize="14px"
        borderRadius={5}
        marginLeft="auto"
        onClick={handleMiniMode}
      />
      <Button
        width=""
        height="60%"
        buttonTextColor={Theme.textColor.light}
        buttonBackground={Theme.color.BLUE_6}
        buttonName="Full Screen"
        buttonIcon={faExpand}
        buttonFontSize="14px"
        borderRadius={5}
        marginLeft="3%"
        onClick={handleFullScreen}
      />
    </Wrapper>
  );
};
